import React from 'react';

const ReleaseNotes = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15.5" fill="white" stroke="#E6E9EC" />
      <path
        d="M22 15.4515V16.0035C21.9993 17.2973 21.5803 18.5562 20.8056 19.5925C20.0309 20.6288 18.942 21.3869 17.7012 21.7538C16.4604 22.1206 15.1344 22.0766 13.9207 21.6281C12.707 21.1798 11.6708 20.3511 10.9666 19.2656C10.2624 18.1802 9.92787 16.8962 10.013 15.6052C10.0981 14.3142 10.5983 13.0852 11.439 12.1017C12.2796 11.1181 13.4157 10.4327 14.6777 10.1475C15.9398 9.86238 17.2602 9.99284 18.442 10.5194M22 11.2034L16 17.2094L14.2 15.4095"
        stroke="#4E40EF"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReleaseNotes;
